<template>
  <v-flex>
    <v-title>Start Order</v-title>
    <v-stepper v-model="step">
      <v-stepper-header>
        <v-stepper-step step="1" :complete="step > 1">
          Choose Type
          {{
            customerType
              ? ` (${
                  customers.filter((x) => x.value == customerType)[0].type
                } )`
              : ''
          }}
        </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="2" :complete="step > 2">
          Plans on Order
        </v-stepper-step>
      </v-stepper-header>
      <v-stepper-items>
        <v-stepper-content step="1">
          <v-card class="mb-5" height="200px">
            <v-radio-group
              v-model="customerType"
              column
              hide-details
              mandatory
              required
              tabindex="0"
              toggle-keys="[13\,32]"
              validate-on-blur
            >
              <v-radio
                v-for="(item, index) in customers"
                :key="index"
                color="primary"
                :label="item.type"
                :ripple="true"
                :value="item.value"
              ></v-radio>
            </v-radio-group>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click.native="step = 2">Continue</v-btn>
            </v-card-actions>
          </v-card>
        </v-stepper-content>
        <v-stepper-content step="2">
          <v-card class="mb-5" height="200px">
            <v-radio-group
              v-model="orderType"
              column
              hide-details
              mandatory
              required
              tabindex="0"
              toggle-keys="[13\,32]"
              validate-on-blur
            >
              <v-radio
                v-for="(item, index) in orders.filter((x) =>
                  x.conditions.some((y) => y == customerType || y === 'all')
                )"
                :key="index"
                color="primary"
                :label="item.type"
                :ripple="true"
                :value="item.value"
              ></v-radio>
            </v-radio-group>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click.native="startOrder">Continue</v-btn>
              <v-btn @click.native="step = 1">Cancel</v-btn>
            </v-card-actions>
          </v-card>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </v-flex>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import customer from '../../../store/modules/forms/customer';
const { mapMutations: mapOrderMutations } = createNamespacedHelpers(`orders`);
export default {
  name: 'OrderStepper',
  data() {
    return {
      step: 1,
      customerType: null,
      customers: [
        { type: 'New - Business', value: 'newBusiness' },
        { type: 'New - Residential', value: 'newResidential' },
        { type: 'Existing - Business', value: 'existingBusiness' },
        { type: 'Existing - Residential', value: 'existingResidential' },
      ],
      orderType: null,
      orders: [
        {
          type: 'Plans with Handset Rental',
          value: 'upgradeQBR',
          conditions: ['newBusiness', 'existingBusiness'],
        },
        {
          type: 'Vonex Standard Plans',
          value: 'standard',
          conditions: ['all'],
        },
        {
          type: 'Add Softphone to Existing Services',
          value: 'softphone',
          conditions: ['existingBusiness', 'existingResidential'],
        },
      ],
    };
  },
  methods: {
    ...mapOrderMutations(['setAddSoftphone']),
    startOrder() {
      let vm = this;
      vm.setAddSoftphone(false);
      if (this.orderType == 'QBR' && this.customerType == 'newBusiness') {
        this.$emit('orderType', 'qantas');
        return;
      }
      if (this.orderType == 'standard' && this.customerType === 'newBusiness') {
        this.$emit('orderType', 'business');
        return;
      }
      if (
        this.customerType === 'newBusiness' &&
        this.orderType == 'upgradeQBR'
      ) {
        this.$emit('orderType', 'qantas');
        return;
      }
      if (
        this.orderType == 'standard' &&
        this.customerType === 'newResidential'
      ) {
        this.$emit('orderType', 'residential');
        return;
      }
      if (
        this.customerType === 'existingResidential' &&
        this.orderType == 'standard'
      ) {
        this.$emit('orderType', 'existingResidential');
        return;
      }
      if (
        this.customerType === 'existingResidential' &&
        this.orderType == 'softphone'
      ) {
        this.$emit('orderType', 'existingResidential');
        return;
      }
      if (
        this.customerType === 'existingBusiness' &&
        this.orderType == 'softphone'
      ) {
        vm.setAddSoftphone(true);
        this.$emit('orderType', 'standard');
        return;
      }
      if (
        this.orderType == 'upgradeQBR' &&
        this.customerType === 'existingBusiness'
      ) {
        this.$emit('orderType', 'upgradeQBR');
        return;
      }
      if (this.orderType == 'QBR' && this.customerType === 'existingBusiness') {
        this.$emit('orderType', 'additionalQBR');
        return;
      }

      if (
        this.orderType == 'standard' &&
        this.customerType === 'existingBusiness'
      ) {
        this.$emit('orderType', 'standard');
        return;
      }
    },
  },
};
</script>

<style scoped>
:focus {
  outline: none;
  outline-color: transparent;
  outline-style: auto;
  outline-width: 0px;
}
</style>
